@if (_actionGroup) {
  <div [class]="classNames">
    @for (item of _actionGroup.actions; track item) {
      <sh-action-item
        [inOverflownContainer]="inOverflownContainer"
        [class]="groupItemClassNames"
        [bubbleEvent]="bubbleEvent"
        [item]="item"
        [childComponentClasses]="childComponentClasses"
        >
      </sh-action-item>
    }
  </div>
}
